<!-- 店铺商品页面 -->
<template>
  <div id="commodity">
    <!-- :fid="Number($route.query.storeId)" :forder="Number($route.query.forder)" -->
    <MySizer :fname="$route.query.name" :val="3" :isprice="1" :slot-item="slotItem" @onActive="onActive($event)" @onScreen="onScreen($event)" @onPrice="onPrice($event)">
      <span slot="1">综合</span>
      <span slot="2">销量</span>
      <span slot="3">价格</span>
    </MySizer>
    <comList :com-list="shopData" />
    <div v-if="$route.query.name === '商品'" class="footer-page">
      <el-pagination
        class="commodity-pagination"
        background
        :current-page.sync="currentPage"
        :page-sizes="[50, 100, 200]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <div v-if="false" class="no-data">
      <img src="@/assets/images/no-data.png" alt="">
      <p>未能搜索到符合条件的商品，请重新输入价格区间！</p>
    </div>
  </div>
</template>

<script>
import MySizer from '@/components/sizer/index.vue' // 筛选组件
import comList from '../components/commodityList/index.vue' // 商品组件
import { queryMallStoreStockInfo } from '@/api/shop.js'
export default {
  components: {
    comList,
    MySizer
  },
  data() {
    return {
      // 插槽内箭头是否展示
      slotItem: [
        {},
        { hasArrow: true },
        { hasArrow: true }
      ],
      active: 1,
      maxPrice: null,
      minPrice: null,
      sortVal: -1,
      shopData: [],
      currentPage: 1,
      pageSize: 50,
      total: 0
    }
  },
  watch: {
    '$route'(val) {
      this.onSearch(val.query.keyWord)
    }
  },
  /**
   * keep-alive生命周期调用时，改变全局背景颜色
   */
  activated() {
    document.getElementById('storeApp').setAttribute('style', 'background-color:#ffffff;')
  },
  /**
   * keep-alive生命周期取消掉用，取消改变背景颜色
   */
  deactivated() {
    document.getElementById('storeApp').removeAttribute('style')
  },
  created() {
    this.$nextTick(() => {
      const query = this.$route.query
      if (query.index !== undefined) {
        this.$store.commit('store/SET_NOWINDEX', query.index)
      }
      if (query.keyWord !== undefined) {
        this.onSearch(query.keyWord)
        return
      }
      this.onSearch()
    })
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    },
    handleCurrentChange() {
      this.onSearch()
    },
    onActive(e) {
      this.active = Number(e)
      this.onSearch()
    },
    onScreen(e) {
      if (e.buttonType === 'bottom') {
        this.sortVal = 1
      } else {
        this.sortVal = 0
      }
    //   this.onSearch()
    },
    onPrice(e) {
      this.maxPrice = e.maxPrice || null
      this.minPrice = e.minPrice || null
      this.onSearch()
    },
    onSearch(Keyword) {
      let sortVal = -1
      if (this.active > 1) {
        sortVal = this.sortVal
      }
      const jsonobj = {
        FMallStoreId: Number(this.$route.query.storeId),
        StorePageNavigationFOrder: Number(this.$route.query.forder),
        FNavigationName: this.$route.query.name,
        Keyword: '',
        FBeginTime: '',
        FEndTime: '',
        FMinPrice: this.minPrice,
        FMaxPrice: this.maxPrice,
        FSortType: this.active - 1,
        FSortVal: sortVal
      }
      if (Keyword !== undefined) {
        jsonobj.Keyword = Keyword
      }
      const params = new URLSearchParams()
      params.append('pageNo', this.currentPage)
      params.append('pageSize', this.pageSize)
      params.append('jsonobj', JSON.stringify(jsonobj))
      queryMallStoreStockInfo(params)
        .then(res => {
          this.shopData = res.data.records
          this.total = res.data.total
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  #commodity{
      .footer-page {
            position: relative;
            width: 100%;
            height: 50px;
            .el-pagination {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            }
        }
    .no-data{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 92px 0;
      img{
        width: 184px;
        height: 184px;
      }
      p{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
    }
  }
</style>
